<template>
  <div class="manage">
    <div class="content">
      <el-dialog custom-class="custem" :title="operateType === 'add' ? '资源管理' : '资源管理'" :visible.sync="isShow">
       <EditTable :edit="edit" :ruleForm="ruleForm" ></EditTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShow = false">关 闭</el-button>
          <el-button  v-show="edit" type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>

      <div class="manage-header" style="padding-top:30px">
          <div>
              <el-button type="primary" @click="addUser">+ 新增</el-button>
              <el-button type="primary" @click="addUser">下载模板</el-button>
                  <el-button type="primary" @click="addUser">导入</el-button>
          </div>
        <common-form inline :formLabel="formLabel" :form="searchFrom">
          <el-button type="primary" @click="getList(searchFrom.keyword)">搜索</el-button>
        </common-form>
      </div>
      <el-row :gutter="20">
        <!-- <el-col :span="4">
          <div style="position: absolute;top:15%;width: 15%;right: 35%;z-index: 9;">
            <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
          </div>
        </el-col> -->
        <el-col :span="24">
          <common-table style="width:100%;height:600px;" 
          :formLabel="Label" 
          :tableData="tableData" 
          :tableLabel="tableLabel" 
          :config="config" 
          @changePage="getList()" 
          @edit="editUser" 
          @del="delUser"
          @close="closeDeat" 
          @detail="detailUser"
          @open="openDeat"></common-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import CommonForm from '../../components/CommonForm'
import CommonTable from '../../components/CommonTable'
import EditTable from '../../components/resouse/security'
export default {
  components: {
    CommonForm,
    CommonTable,
    EditTable
  },
  data() {
    return {
      edit: false,
      data: [{
          id: 1,
          label: '一级 2',
          children: [{
            id: 3,
            label: '二级 2-1',
            children: [{
              id: 4,
              label: '三级 3-1-1'
            }, {
              id: 5,
              label: '三级 3-1-2',
            }]
          }, {
            id: 2,
            label: '二级 2-2',
            disabled: true,
            children: [{
              id: 6,
              label: '三级 3-2-1'
            }, {
              id: 7,
              label: '三级 3-2-2',
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
      Label:{
        add:true,
        edit:true,
        detail:true,
        disable:true
      },
       ruleForm:{
          XJTMBH:'',
          XJTMMC:'',
          SJXJTM:'',
          XJTMNR:'',
          XJTMZGFF:'',
          FXDJ:'',
          CJ:''
      },
      operateType: 'add',
      isShow: false,
      tableData: [],
      tableLabel: [
        {
          prop: 'XJTMMC',
          label: '安全条目名称',
          width:150
        },
        {
          prop: 'XJTMNR',
          label: '安全条目内容',
          width:120
        },
        {
          prop: 'XJTMZGFF',
          label: '整改方法',
          width:150
        },
        {
          prop: 'SJXJTM',
          label: '上级安全条目',
          width:120
        },
        {
          prop: 'FXDJ',
          label: '安全等级',
           width:100
        },
        {
          prop: 'BZ',
          label: '备注',
          width:100
        },
         {
          prop: 'QYBZ',
          label: '是否启用',
          width:100
        }

      ],
      config: {
        page: 1,
        total: 30,
        loading: false
      },
      operateForm: {
        name: '',
        addr: '',
        age: '',
        birth: '',
        sex: ''
      },
      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: ''
        }
      ]
    }
  },
  methods: {
     openDeat(row){
       this.$confirm('确定启用此用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
      },
    closeDeat(row) {
       this.$confirm('确定禁用此用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

    },
    handleNodeClick(data) {
        this.getList()
      },
    getList(name = '') {
      this.config.loading = true
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      name ? (this.config.page = 1) : ''
      this.$http
        .get('/api/user/getUser', {
          params: {
            page: this.config.page,
            name
          }
        })
        .then(res => {
          this.tableData = res.data.list.map(item => {
            item.start = item.start === 0 ? '启用':'禁用'
            return item
          })
          this.config.total = res.data.count
          this.config.loading = false
        })
    },
    addUser() {
      
      this.ruleForm = {}
      this.operateType = 'add'
      this.edit = true
      this.isShow = true
    },
    editUser(row) {
      this.edit = true
      this.operateType = 'edit'
      this.isShow = true
      this.ruleForm = row
      
    },
     detailUser(row){
       this.isShow = true
       this.ruleForm = row
       this.edit = false
    },
     quite(){
      this.isShow = false
      if(this.edit){
        this.edit = false
      }else{
        this.edit = true
      }     
    },
    confirm() {
      if (this.operateType === 'edit') {
        this.$http.post('/api/user/edit', this.operateForm).then(res => {
          this.isShow = false
          this.getList()
        })
      } else {
        this.$http.post('/api/user/add', this.operateForm).then(res => {
          this.isShow = false
          this.getList()
        })
      }
    },
    delUser(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = row.id
          this.$http
            .get('/api/user/del', {
              params: {
                id
              }
            })
            .then(res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
@import '@/assets/scss/allPage';
.manage {
  padding: 20px;
  height: 100%;
  .content {
    width: 100%;
    height: 100%;
    background: rgba(50,58,82,0.25);
    border: 1px solid rgba(122,139,168,0.15);
    border-radius: 8px;
    opacity: 0.85;
    .manage-header {
      // margin-top: 30px;
      padding: 0 30px;
      & /deep/ .el-button {
        color: #fff;
        width: 150px;
        height: 36px;
        line-height: 10px;
        border: 1px solid rgba(33,150,227,0.50);
        border-radius: 4px;
        margin: 0 10px;
      }
    }
  }
  & /deep/ .el-dialog__footer {
    background: #011e43;
    text-align: right;
    .el-button {
      color: #fff;
      width: 100px;
      border: 1px solid rgba(33,150,227,0.50);
      border-radius: 4px;
      margin: 0 10px;
    }
  }
}
</style>
